type SwitchButtonProps = {
  width: string;
  isRightButtonSelected: boolean;
  rightButtonTitle: string;
  leftButtonTitle: string;
  handleChange?: (item?: SelectItem) => void;
};

export default function SwitchButton({
  width,
  isRightButtonSelected,
  rightButtonTitle,
  leftButtonTitle,
  handleChange,
}: SwitchButtonProps) {
  return (
    <div className={`relative flex h-auto rounded-xl ${width}`}>
      <button
        className={`switch-button-right font-medium ${
          isRightButtonSelected
            ? "bg-tertiary shadow-none translate-y-1"
            : "bg-bg shadow-normal"
        }`}
        onClick={() => handleChange()}
      >
        {rightButtonTitle}
      </button>
      <button
        className={`switch-button-left font-medium ${
          !isRightButtonSelected
            ? "bg-tertiary shadow-none translate-y-1"
            : "bg-bg shadow-normal"
        }`}
        onClick={() => handleChange()}
      >
        {leftButtonTitle}
      </button>
    </div>
  );
}
